<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-22 13:02:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-03-22 14:06:30
 * @Description: radio group 组件
 * @FilePath: /hsylc2021/src/components/form/RadioGroup/index.vue
-->
<template>
  <Prototype
    :className="className"
    :disabled="disabled"
    :value="value"
    :options="options"
    :keyStr="keyStr"
    :reverse="reverse"
    :multi="multi"
    @input="handleInput"
  >
    <div v-if="isError && isVerific" class="errmsg">{{ errmsgVal }}</div>
  </Prototype>
</template>
<script>
import Prototype from './Prototype';
/**
 * radiogroup组件
 * @module RadioGroup
 */
export default {
  name: 'RadioGroup',
  components: {
    Prototype
  },
  /**
   * @prop {String} className 组件外部class
   * @prop {Boolean} disabled 是否禁用
   * @prop {Array} value 组件数据
   * @prop {Array} options 组件来源数据列表
   * @prop {String} keyStr 唯一标志字段名，默认value
   * @prop {Boolean} reverse 是否支持反选 默认false
   * @prop {Boolean} multi 是否支持多选 默认false
   * @prop {Boolean} errmsg 报错信息 默认 未填写
   * @prop {Boolean} startVerific 是否开启验证 用户是否选择默认false
   */
  props: {
    className: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function() {
        return [];
      }
    },
    options: {
      type: Array,
      default: function() {
        return [];
      }
    },
    keyStr: {
      type: String,
      default: 'value'
    },
    reverse: {
      type: Boolean,
      default: false
    },
    multi: {
      type: Boolean,
      default: false
    },
    errmsg: {
      type: String,
      default: '未填写'
    },
    startVerific: {
      type: Boolean,
      default: false
    },
    // 是否 开启报错信息
    isVerific: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isError: false, // 是否 选中
      errmsgVal: '未填写'
    };
  },
  watch: {
    errmsg(val) {
      this.errmsgVal = val;
    },
    startVerific(val) {
      if (val) this.checkGroup();
    },
    value() {
      if (this.startVerific) {
        this.checkGroup();
      }
    }
  },
  mounted() {
    this.errmsgVal = this.errmsg;
    if (this.startVerific) {
      this.checkGroup();
    }
  },
  methods: {
    // 检查 选项组 是否为空
    checkGroup() {
      let ret = this.value;
      let isError = ret.length === 0 ? true : false;
      this.isError = isError;
      // console.log(ret, isError);

      return isError;
    },
    handleInput(value) {
      this.isError = !value.length;
      this.$emit('input', value, this.isError, this.errmsg);
    }
  }
};
</script>
<style lang="less" scoped></style>
